import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Settings } from 'lucide-react';
import Alert from '../common/Alert.js';
import roleService from '../../services/RoleService.js';
import { PageLayout, FormLayout, FormField } from '../common/index.js';

const EditRole = () => {
  const { roleId } = useParams();
  const [formData, setFormData] = useState({
    role_name: '',
  });
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchRole();
  }, [roleId]);

  const fetchRole = async () => {
    try {
      const response = await roleService.getById(roleId);
      setFormData(response.data);
    } catch (err) {
      Alert.error('Failed to load role data');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      await roleService.update(roleId, formData);
      Alert.success('Role updated successfully!');
      setTimeout(() => navigate('/roles'), 1500);
    } catch (err) {
      Alert.error(err.response?.data?.error || 'Failed to update role');
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <PageLayout title="Edit Role" icon={Settings}>
        <div className="flex items-center justify-center py-20">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand mx-auto mb-4" />
            <p className="text-sm text-gray-600">Loading role data...</p>
          </div>
        </div>
      </PageLayout>
    );
  }

  return (
    <FormLayout
      title="Edit Role"
      icon={Settings}
      onSubmit={handleSubmit}
      submitLabel={submitting ? 'Updating...' : 'Update Role'}
      loading={submitting}
      onCancel={() => navigate('/roles')}
      maxWidth="max-w-7xl"
    >
      <div>
        <h3 className="text-base font-semibold text-secondary mb-4 pb-2 border-b border-gray-100">
          Role Information
        </h3>
        <FormField label="Role Name" required className="sm:w-1/3">
          <input
            type="text"
            name="role_name"
            value={formData.role_name}
            onChange={handleChange}
            className="input-clean"
            required
          />
          <p className="text-xs text-gray-600 mt-2">Update the role name as needed</p>
        </FormField>
      </div>
    </FormLayout>
  );
};

export default EditRole;
